import { createReducer, on } from '@ngrx/store';
import {
  CreateTagCodeChanged,
  CreateTagLabelChanged,
  CreateTagTypeChanged,
  LoadTagTypes,
  ResetCreateNewState,
  UserSubmitted,
} from '../actions/create-new-tag.actions';
import { CreateNewTagManagementState } from '../models/search-filters.model';

const initialState: CreateNewTagManagementState = {
  createTagTypeValues: [],
  createTagType: '',
  createTagCode: '',
  createTagLabel: '',
  userSubmitted: false,
};

export const createNewTagReducer = createReducer(
  initialState,
  on(LoadTagTypes, (state, { createTagTypeValues }) => ({
    ...state,
    createTagTypeValues,
  })),
  on(CreateTagTypeChanged, (state, { createTagType }) => ({
    ...state,
    createTagType: createTagType ?? '',
  })),
  on(CreateTagCodeChanged, (state, { createTagCode }) => ({
    ...state,
    createTagCode,
  })),
  on(CreateTagLabelChanged, (state, { createTagLabel }) => ({
    ...state,
    createTagLabel,
  })),
  on(UserSubmitted, (state) => ({
    ...state,
    userSubmitted: true,
  })),
  on(ResetCreateNewState, () => initialState),
);
